import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appScrollbarToBottom]'
})
export class ScrollbarToBottomDirective {

  constructor(private _el: ElementRef) { }


  scrollToBottom() {
    const el: HTMLDivElement = this._el.nativeElement;
    el.scrollTop = Math.max(0, el.scrollHeight - el.offsetHeight);
  }


}
